import { useState } from "react";
import BlockShell from "./BlockShell";
import Lightbox from "../Lightbox";
import { absUrl } from "./media";

const PhotoGalleryBlock = ({ block }) => {
  const cfg = block.config || {};
  const [zoom, setZoom] = useState(null);
  const cols = Number(cfg.columns) || 3;
  const gridCls = { 2: "grid-cols-2", 3: "grid-cols-2 md:grid-cols-3", 4: "grid-cols-2 md:grid-cols-4" }[cols] || "grid-cols-2 md:grid-cols-3";
  return (
    <section className="max-w-7xl mx-auto px-6 md:px-12 py-8" data-testid="fest-gallery">
      <BlockShell block={block}>
        <div className={`grid ${gridCls} gap-3 ${cfg.fit === "natural" ? "items-start" : ""}`}>
          {(cfg.images || []).map((img, i) => (
            <button type="button" key={img} onClick={() => setZoom(absUrl(img))} className="cursor-zoom-in group" aria-label="Enlarge photo" data-testid={`fest-gallery-image-${i}`}>
              <img src={absUrl(img)} alt="" className={`w-full rounded-md border shadow-sm transition-transform group-hover:scale-[1.02] ${cfg.fit === "natural" ? "h-auto" : "aspect-square object-cover"}`} loading="lazy" />
            </button>
          ))}
          {(cfg.images || []).length === 0 && (
            <p className="text-sm italic text-[#5C5C5C] col-span-full">No photos yet — add some in the block editor.</p>
          )}
        </div>
        <Lightbox src={zoom} onClose={() => setZoom(null)} />
      </BlockShell>
    </section>
  );
};

export default PhotoGalleryBlock;
